export default "__VITE_ASSET__CA6AEcZ9__"